<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import type { StepperRootEmits, StepperRootProps } from 'reka-ui';
import { StepperRoot, useForwardPropsEmits } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<
    StepperRootProps & { class?: HTMLAttributes['class'] }
>();
const emits = defineEmits<StepperRootEmits>();

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <StepperRoot
        v-slot="slotProps"
        :class="
            cn(
                'flex gap-2',
                {
                    'flex-col gap-y-6': props.orientation === 'vertical',
                },
                props.class
            )
        "
        v-bind="forwarded"
    >
        <slot v-bind="slotProps" />
    </StepperRoot>
</template>
